var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"tile":"","flat":""}},[_c('v-card-title',[_vm._v(_vm._s(_vm.category.title))]),_c('v-card-text',[(_vm.category.children)?_c('recursive-documents',{attrs:{"items":_vm.category.children}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }